import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { Dialog, DialogContent } from './ui/dialog';
import { Button } from './ui/button';
import { X, ZoomIn, ZoomOut, RotateCw } from 'lucide-react';

export default function ImageLightbox({ open, onClose, imageSrc, imageAlt = 'Image' }) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-6xl h-[90vh] p-0">
        <div className="relative w-full h-full bg-black">
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            className="absolute top-4 right-4 z-50 bg-black/50 text-white hover:bg-black/70 rounded-full"
          >
            <X className="h-5 w-5" />
          </Button>
          
          <TransformWrapper
            initialScale={1}
            minScale={0.5}
            maxScale={4}
          >
            {({ zoomIn, zoomOut, resetTransform }) => (
              <>
                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-50 flex gap-2 bg-black/50 p-2 rounded-full">
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => zoomOut()}
                    className="text-white hover:bg-white/20 rounded-full"
                  >
                    <ZoomOut className="h-5 w-5" />
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => resetTransform()}
                    className="text-white hover:bg-white/20 rounded-full"
                  >
                    <RotateCw className="h-5 w-5" />
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => zoomIn()}
                    className="text-white hover:bg-white/20 rounded-full"
                  >
                    <ZoomIn className="h-5 w-5" />
                  </Button>
                </div>
                
                <TransformComponent wrapperClass="w-full h-full" contentClass="w-full h-full flex items-center justify-center">
                  <img
                    src={imageSrc}
                    alt={imageAlt}
                    className="max-w-full max-h-full object-contain"
                  />
                </TransformComponent>
              </>
            )}
          </TransformWrapper>
        </div>
      </DialogContent>
    </Dialog>
  );
}
